import { BasicCloudinaryAsset } from '../../../../utils/getCloudinaryItem/getCloudinaryItem';
type ScrollingImage = {
  image: BasicCloudinaryAsset;
  alt: string;
  style: {
    animationDelay: number;
    mobileAnimationDelay: number;
    animationDuration: number;
    zIndex: number;
    top: number;
  };
};
type BusinessLineData = {
  images: ScrollingImage[];
};
export const businessLineData: BusinessLineData = {
  images: [{
    alt: "Model wearing Stitch Fix women's clothes including a mustard cardigan, a plaid midi skirt, dark brown knee-high boots, and a brown shoulder bag.",
    image: {
      path: 'v1786051459/creative/onboarding/AO-WMK27-PMM-Site-Q127-Seasonal-Site-Updates/onboarding-1.png',
      height: 1200,
      width: 800
    },
    style: {
      animationDelay: -86,
      mobileAnimationDelay: -56,
      animationDuration: 102,
      zIndex: 2,
      top: 103
    }
  }, {
    alt: "Model wearing Stitch Fix men's clothes including a light gray short-sleeve polo sweater, light wash jeans, and a black watch.",
    image: {
      path: 'v1786051459/creative/onboarding/AO-WMK27-PMM-Site-Q127-Seasonal-Site-Updates/onboarding-2.png',
      height: 1200,
      width: 800
    },
    style: {
      // using a negative delay value suggests that animation has been playing for that amount of time;
      // that way, images will automatically show up in the viewport on page load
      animationDelay: -78,
      mobileAnimationDelay: -47,
      animationDuration: 105,
      zIndex: 3,
      top: 4
    }
  }, {
    alt: "Model wearing Stitch Fix women's clothes including a green printed maxi dress and tan platform sandals, with kids wearing Stitch Fix kids' clothes including a green cardigan, a blue striped top, and light wash jeans.",
    image: {
      path: 'v1786051459/creative/onboarding/AO-WMK27-PMM-Site-Q127-Seasonal-Site-Updates/onboarding-3.png',
      height: 1200,
      width: 800
    },
    style: {
      animationDelay: -67,
      mobileAnimationDelay: -34,
      animationDuration: 108,
      zIndex: 1,
      top: 83
    }
  }, {
    alt: "Model wearing Stitch Fix women's clothes including a light blue striped button-up shirt, dark denim jeans, a gray sweater, and a black handbag.",
    image: {
      path: 'v1786051459/creative/onboarding/AO-WMK27-PMM-Site-Q127-Seasonal-Site-Updates/onboarding-4.png',
      height: 1200,
      width: 800
    },
    style: {
      animationDelay: -51,
      mobileAnimationDelay: -19,
      animationDuration: 105,
      zIndex: 3,
      top: 0
    }
  }, {
    alt: "Model wearing Stitch Fix women's clothes including a gray sweatshirt, brown pants, a navy baseball cap, and navy sneakers.",
    image: {
      path: 'v1786051459/creative/onboarding/AO-WMK27-PMM-Site-Q127-Seasonal-Site-Updates/onboarding-5.png',
      height: 1200,
      width: 800
    },
    style: {
      animationDelay: -42,
      mobileAnimationDelay: -9,
      animationDuration: 110,
      zIndex: 5,
      top: 111
    }
  }, {
    alt: "Model wearing Stitch Fix men's clothes including a light blue striped button-up shirt, a white T-shirt, light wash jeans, and black loafers.",
    image: {
      path: 'v1786051459/creative/onboarding/AO-WMK27-PMM-Site-Q127-Seasonal-Site-Updates/onboarding-6.png',
      height: 1200,
      width: 800
    },
    style: {
      animationDelay: -28,
      mobileAnimationDelay: 4,
      animationDuration: 108,
      zIndex: 4,
      top: 22
    }
  }, {
    alt: "Model wearing Stitch Fix kids' clothes including a red polka-dot dress and black ankle boots.",
    image: {
      path: 'v1786051459/creative/onboarding/AO-WMK27-PMM-Site-Q127-Seasonal-Site-Updates/onboarding-7.png',
      height: 1200,
      width: 800
    },
    style: {
      animationDelay: -16,
      mobileAnimationDelay: 14,
      animationDuration: 110,
      zIndex: 6,
      top: 98
    }
  }, {
    alt: "Model wearing Stitch Fix men's clothes including a green striped rugby shirt, navy trousers, and a silver watch.",
    image: {
      path: 'v1786051459/creative/onboarding/AO-WMK27-PMM-Site-Q127-Seasonal-Site-Updates/onboarding-8.png',
      height: 1200,
      width: 800
    },
    style: {
      animationDelay: -1,
      mobileAnimationDelay: 28,
      animationDuration: 108,
      zIndex: 4,
      top: 20
    }
  }]
};